import { sendJson } from '../backend/Backend';

export const userService = {
    login,
    logout,
    getAll,
    authHeader
};

function createUser( email, password ) {
    return {
      firstname:'',
      lastname:'',
      email:email,
      pwd: password,
      userRole:'ANONYMOUS',
      modificationUser:'react'
    };
  }

export function login(username, password) {
    
   let user =  createUser(username, password);
    

    return sendJson('post', 'users/login', user).then(
        received => {
          if(received.id > 0){
              console.log("user ist korrekt");
              // store user details and basic auth credentials in local storage 
                // to keep user logged in between page refreshes
                //user.authdata = window.btoa(username + ':' + password);
                localStorage.setItem('user', JSON.stringify(received));
          } else {
               console.log("password ist falsch");
          }
        }); 

}

export function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

export function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`/users`, requestOptions).then(handleResponse);
}

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                // ???? location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
 
}

export function authHeader() {
    // return authorization header with basic auth credentials
    let user = JSON.parse(localStorage.getItem('user'));

    if (user && user.authdata) {
        return { 'Authorization': 'Basic ' + user.authdata };
    } else {
        return {};
    }
}
